@if (productId) {
  <div>
    @if (isFetching$ | async) {
      <div class="content-loader mt-5">
        <div class="inline-loader"></div>
      </div>
    } @else {
      @if (ordersDetails$ | async; as orderDetails) {
        <app-product-order-details-table
          [orderDetails]="orderDetails"
          [mobile]="mobile"
          [modal]="modal"
          (exportToExcel)="exportToExcel()"
          (exportToPdf)="exportToPDF()"
          (showDetails)="showFullView()"
        ></app-product-order-details-table>
      }
    }
  </div>
}
